import { render, staticRenderFns } from "./trabaja-nosotros-2.vue?vue&type=template&id=3b5d84f8"
import script from "./trabaja-nosotros-2.vue?vue&type=script&lang=js"
export * from "./trabaja-nosotros-2.vue?vue&type=script&lang=js"
import style0 from "./trabaja-nosotros-2.vue?vue&type=style&index=0&id=3b5d84f8&prod&lang=scss"
import style1 from "./trabaja-nosotros-2.vue?vue&type=style&index=1&id=3b5d84f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports